import { render, staticRenderFns } from "./index.vue?vue&type=template&id=580c2bcf"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580c2bcf')) {
      api.createRecord('580c2bcf', component.options)
    } else {
      api.reload('580c2bcf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=580c2bcf", function () {
      api.rerender('580c2bcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formViewItem/index.vue"
export default component.exports